/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';

/*Components*/
import Input from '../../components/formComponents/input';


/*Assets*/

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import GetURLVar from '../../services/getParams/get-url-var';

class SignupTab5 extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: ""
    }
  }

  componentDidMount() {
    GetURLVar().then(function(query){
      if(query.type){
        this.setState({otp: query.key, mail: query.email});
      }
    }.bind(this))
  }

  async buttonClick(e){
    if(this.state.confirm != this.state.password){
      this.setState({error: "Confirm password must same as new password."});
    }
    else{
      var url = devconfig.vendor+'auth/create-password';
      if(this.props.reset){
        url = devconfig.localVendor+'auth/reset-password';
      }
      var data = JSON.stringify({
        "key" : this.state.otp,
        "email" : this.state.mail,
        "password": this.state.password
      })
      await APIPost(url,data).then(function(response){
        if(response.status == "ok"){
          if(!this.props.reset){
            window.location.href = './?success=true';
          }
          else{
            window.location.href = './?reset=true';
          }
        }
        else{
          this.setState({error: response.message});
        }
      }.bind(this))
    }
  }

  render() {
    if(this.state.apiLoading){
      return(
        null
      )
    }
    return (
      <div className="col-lg-6 col-sm-10 col-11 mx-auto e-outer-wrap p-5">
        <div className="row">
          <div className="col-lg-12">
            <h5>Create a password.</h5>
          </div>
        </div>
        <div className="row pt-4">
          {/*<div className="col-12">
            <label>One time password (OTP)</label>
            <Input id="e-otp" value={this.state.otp} type="text" className="e-profile-edit" valueChange={(e) => {this.setState({otp: e}) }}/>
          </div>*/}
          <div className="col-12">
            <label>New Password</label>
            <Input id="e-otp" value={this.state.password} type="password" className="e-profile-edit" valueChange={(e) => {this.setState({password: e}) }}/>
          </div>
          <div className="col-12 pt-3">
            <label>Confirm Password</label>
            <Input id="e-otp" value={this.state.confirm} type="password" className="e-profile-edit" valueChange={(e) => {this.setState({confirm: e}) }}/>
          </div>
          <div className="col-12 pt-3">
            <ul className="e-password-instruction">
              <li>Password Need atleast one special character</li>
              <li>Password Need atleast one number</li>
              <li>Password Need atleast one alphabet</li>
              <li>Password Need Minimum 8 characters</li>
            </ul>
          </div>
        </div>

        {
          this.state.error.length ?
            <div className="row">
              <div className="col-12">
                <div className="e-error">{this.state.error}</div>
              </div>
            </div>
          :
            null
        }
        
        
        <div className="row">
          <div className="col-lg-12 mt-3">
            {
              this.state.otp && this.state.password && this.state.confirm ?
                <span className="e-signup-btn" onClick={this.buttonClick.bind(this)}>Set Password</span>
              :
                <span className="e-signup-btn e-in-active">Set Password</span>
            }
          </div>
        </div>

      </div>
    );
  }
}

export default SignupTab5;
